// eslint-disable-next-line no-restricted-imports
import { useLocation, useNavigate } from 'react-router-dom';
import { useTimeoutFn } from 'react-use';

import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

export const AnalyticsFeedbackView = (): null => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // Shows the feedback modal after a short delay.
  useTimeoutFn(async () => {
    const { isSent, isCancelled } = await dispatch(
      appActions.showModal({
        modal: {
          type: 'app:feedbackForm',
          arg: {
            title: 'Analytics Feedback',
            team: 'insights',
          },
        },
      }),
    );

    // Whenever the feedback modal is closed, navigate back to the parent route.
    if (isSent || isCancelled) {
      navigate(pathname.replace('/feedback', ''), { replace: true });
    }
  }, 2000);

  return null;
};
